import { FunctionComponent, useState } from 'react';

import { Routes } from 'types/routes';

import ContactInfoTile from 'components/content/blocks/ContactInfoTile';
import ContactForm from 'components/content/forms/general/Contact';
import MessageSent from 'components/content/sections/MessageSent';
import BreadCrumbs from 'components/layout/BreadCrumbs/component';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

export interface FormState {
    name: string;
    email: string;
    phone: string;
    message: string;
}

const PageContactSectionContent: FunctionComponent<Props> = ({ translations }) => {
    const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

    return (
        <StyledComponent className="page-contact-section-content">
            <LayoutContainer size={Sizes.Large}>
                <BreadCrumbs elements={[{
                    key: 'home',
                    href: { pathname: Routes.PublicHome },
                    label: translations?.breadCrumbsHome,
                    active: false,
                    disableDivider: true,
                }, {
                    key: 'contact',
                    href: { pathname: Routes.PublicContact },
                    label: translations?.breadCrumbsContact,
                    active: true,
                    disableDivider: false,
                }]}
                />

                {formSubmitted ? (
                    <MessageSent
                        translations={translations}
                        setFormSubmitted={setFormSubmitted}
                    />
                ) : (
                    <div className='content-wrapper'>
                        <ContactForm
                            translations={translations}
                            setFormSubmitted={setFormSubmitted}
                        />
                        <ContactInfoTile translations={translations} />
                    </div>
                )}

            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageContactSectionContent;
